import React, { ReactNode } from "react";
import { AttributeType } from "@evergis/api";

import { FeatureCardCheckbox } from "../components/FeatureCardCheckbox/FeatureCardCheckbox";
import { TextTrim } from "../components/TextTrim/TextTrim";
import { getAttribute } from "./getAttribute";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getAttributeValue = (
  element: ConfigContainerChild,
  attributes: FeatureAttribute[],
): ReactNode | string => {
  const attribute = getAttribute(element, attributes);
  const { maxLength, separator, expandable, lineBreak } = element.options || {};
  let value = "";

  if (attribute?.type === AttributeType.Boolean && typeof attribute.value === "boolean") {
    return <FeatureCardCheckbox title={attribute.alias || attribute.name} checked={attribute.value} />;
  }

  if (Array.isArray(element?.attributeName)) {
    const concatAttributes = element.attributeName.map(
      (attributeName: string) => attributes.find(({ name }) => name === attributeName)?.value || "",
    );

    value = concatAttributes.join(separator || ", ");
  } else {
    value = attribute?.value?.toString() || "";
  }

  return maxLength && maxLength < value.length ? (
    <TextTrim maxLength={maxLength} expandable={expandable} lineBreak={lineBreak}>
      {value}
    </TextTrim>
  ) : (
    value
  );
};
